module.exports = __webpack_public_path__ + "static/templates-e0cc34db19d5fcd42ec1e7a3afdc170d.jpg";